import { createCanvasPlugin } from "./baseCanvas";
import {
  BaseContextProperties,
  CanvasRefProperties,
} from "./contextProperties";
import { NoneMode } from "./PluginSystem";

export type FocusMode = NoneMode;

export type FocusData = {};

export interface FocusContextContext
  extends BaseContextProperties<FocusMode, FocusData>,
    CanvasRefProperties {}

export function focusPlugin() {
  return createCanvasPlugin({
    name: "focus",
    data: {},
    handlers: (context: FocusContextContext) => ({
      onPointerDown() {
        context.canvasRef.current?.focus();
      },
    }),
  });
}
